export default __webpack_public_path__ + "static/lozenge-dropdown-do-2-light-e720a93a2972f843c4d82ebe2f7b6a5bcf6e6a0a209bb07758e38569888400cd.png";